<template>
    <div class="header-component" 
        :style="`position: ${position}; left: ${left}; top: ${top}; background-color: ${background}`"
    >
        <div class="header-component__info-button"
            v-if="infoButton"
            @click="clickInfoButton()"
        >
          <svg  width="23" height="23" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.66272 9.72033C7.66272 9.36477 7.7205 9.05366 7.83605 8.78699C7.9605 8.51144 8.10717 8.28033 8.27605 8.09366C8.45383 7.90699 8.68494 7.68477 8.96939 7.42699C9.32494 7.11588 9.58717 6.84921 9.75605 6.62699C9.92494 6.39588 10.0094 6.12033 10.0094 5.80033C10.0094 5.36477 9.8405 5.0181 9.50272 4.76032C9.16494 4.49366 8.69828 4.36033 8.10272 4.36033C7.06272 4.36033 6.26717 4.71144 5.71605 5.41366L4.74272 4.72033C5.11605 4.24033 5.59161 3.87144 6.16939 3.61366C6.75605 3.35588 7.43161 3.22699 8.19605 3.22699C9.16494 3.22699 9.93383 3.44033 10.5027 3.86699C11.0716 4.28477 11.3561 4.86255 11.3561 5.60033C11.3561 5.96477 11.2938 6.28921 11.1694 6.57366C11.0538 6.84921 10.9116 7.08033 10.7427 7.26699C10.5738 7.45366 10.3472 7.67588 10.0627 7.93366C9.69828 8.26255 9.42717 8.55144 9.24939 8.80033C9.0805 9.04921 8.99605 9.35588 8.99605 9.72033H7.66272ZM8.34272 12.747C8.09383 12.747 7.88494 12.667 7.71605 12.507C7.55605 12.3381 7.47605 12.1337 7.47605 11.8937C7.47605 11.6537 7.55605 11.4537 7.71605 11.2937C7.88494 11.1248 8.09383 11.0403 8.34272 11.0403C8.59161 11.0403 8.79605 11.1248 8.95605 11.2937C9.11605 11.4537 9.19605 11.6537 9.19605 11.8937C9.19605 12.1337 9.11161 12.3381 8.94272 12.507C8.78272 12.667 8.58272 12.747 8.34272 12.747Z" fill="white"/>
            <circle cx="8" cy="8" r="7.5" stroke="white"/>
          </svg>
        </div>
        <div class="header-component__arrow"
            @click="clickBack()"
             :style="`opacity: ${is_back ? '1' : '0'}; cursor: ${is_back ? 'pointer': 'default'}`"
            v-if="!infoButton"
        >
            <svg width="26" height="18" viewBox="0 0 26 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path opacity="0.7" d="M8.4919 17.7293C8.84611 18.0902 9.43563 18.0902 9.80222 17.7293C10.1564 17.3805 10.1564 16.8001 9.80222 16.4522L3.15815 9.91049L25.0827 9.91049C25.5938 9.90967 26 9.50971 26 9.0065C26 8.5033 25.5938 8.09033 25.0827 8.09033L3.15815 8.09033L9.80222 1.56084C10.1564 1.19989 10.1564 0.618644 9.80222 0.27071C9.43563 -0.0902352 8.84528 -0.0902352 8.4919 0.27071L0.274945 8.36104C-0.091647 8.70978 -0.091647 9.29022 0.274945 9.63816L8.4919 17.7293Z" fill="white"/>
            </svg>
        </div>
        <div class="header-component__menu"
            @click="clickMenu()"
            id="header-component__menu"
        >
            <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 14H23M5 8H23M5 20H23" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </div>
        <div class="header-component__timer-wrapper" v-if="is_timer">
          <div class="header-component__timer">
            <span>{{ current }}</span>
            <span style="opacity: .5; margin-left: 15px;">{{ allTime }}</span>
          </div>
        </div>
    </div>
</template>

<script>
    export default {
        async mounted() {
          if(this.is_timer) {
            this.allTime = this.setTime(this.allDuration, 'all')
          }
        },
        props: {
            position: {
                type: String,
                default: 'static'
            },
            top: {
                type: String,
                default: 'auto'
            },
            left: {
                type: String,
                default: 'auto'
            },
            background: {
                type: String,
                default: 'transparent'
            },
            infoButton: {
                default: false
            },
            is_back: {
              default: true
            },
            is_timer: {
              default: false
            },
            currentDuration: {
              default: '00:00'
            },
            allDuration: {
              default: '00"00'
            }
        },
        data() {
          return {
            current: '00:00',
            allTime: '00:00'
          }
        },
        methods: {
            async clickInfoButton() {
                this.$emit('clickInfoButton')
            },
            async clickBack() {
                this.is_back ? this.$emit('clickBack') : false
            },
            async clickMenu() {
                this.$emit('clickMenu')
            },
            setTime(val, type) {
              let time = type === 'current' ? Math.trunc(val / 1000) : val
                if(time < 10) {
                  return `00:0${time}`
                } else {
                  if(time >= 60) {

                    let m = Math.trunc(time / 60)

                    let s = ( time - (m * 60))

                    return `${m > 10 ? m : `0${m}`}:${s >= 10 ? s : `0${s}`}`

                  } else {
                    return `00:${time}`
                  }
                }
            }
        },
        watch: {
          currentDuration(val) {
            this.current = this.setTime(val, 'current')
          },
          allDuration(val) {
            // TODO: не обновляется значение в дереве
            this.allTime = this.setTime(val, 'all')
          }
        },
        computed: {
          // current() {
          //   let time = Math.trunc(this.currentDuration / 1000)
          //   if(time < 10) {
          //     return `00:0${time}`
          //   } else {
          //     if(time >= 60) {
          //
          //       let m = Math.trunc(time / 60)
          //
          //       let s = ( time - (m * 60))
          //
          //       return `${m > 10 ? m : `0${m}`}:${s > 10 ? s : `0${s}`}`
          //
          //     } else {
          //       return `00:${time}`
          //     }
          //   }
          // }
        }
    }
</script>

<style less>

    .header-component {
        height: 44px;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        z-index: 5;
        position: relative;
    }

    .header-component__arrow,
    .header-component__info-button {
        margin-left: 16px;
        cursor: pointer;
        z-index: 1;
    }

    .header-component__menu {
        cursor: pointer;
        margin-right: 15px;
        z-index: 1;
    }

    .header-component__timer-wrapper {
      position: absolute;
      left: 0px;
      top: 0px;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .header-component__timer {
      background: rgba(0, 0, 0, 0.7);
      border-radius: 14px;
      justify-content: space-between;
      display: flex;
      color: #FFFFFF;
      padding: 5px 10px;
    }
</style>